import AppProviders from '@/app/AppProviders';

const App = () => {
  return <AppProviders />;
};

export default App;
